import { render, staticRenderFns } from "./TaxInformationForm.vue?vue&type=template&id=66a4f4fe&scoped=true"
import script from "./TaxInformationForm.vue?vue&type=script&lang=js"
export * from "./TaxInformationForm.vue?vue&type=script&lang=js"
import style0 from "./TaxInformationForm.vue?vue&type=style&index=0&id=66a4f4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4f4fe",
  null
  
)

export default component.exports